import { SvgIcon, type SvgIconProps } from '@mui/material';

const PromoIcon = (props: SvgIconProps) => (
  <SvgIcon viewBox='0 0 24 24' data-testid='PromoIcon' {...props}>
    <path
      fill='currentColor'
      d='M18.022 4.123a1.1 1.1 0 0 0-.754.273l-.768.658L9.456 7.68A.75.75 0 0 0 9 8.37v6.138a.75.75 0 0 0 .45.687l7.05 2.707.705.705c.708.709 1.92.207 1.92-.796V13.49a2.062 2.062 0 0 0 0-4.106V5.25c0-.66-.533-1.113-1.103-1.127M4.741 8.25C3.779 8.25 3 9.001 3 9.927v3.02c0 .927.78 1.678 1.741 1.678h3.134V8.25zm.697 7.5c0 1.658.302 3.1.523 3.656.114.285.39.469.697.469h1.456c.502 0 .86-.48.719-.962-.194-.659-.396-1.998-.396-3.163z'
    />
  </SvgIcon>
);

export default PromoIcon;
